import useTabletLayout from '../hooks/useTabletLayout';

function TabletLayoutWrapper() {
  useTabletLayout();
  return null;
}

export default TabletLayoutWrapper;
